const ConnectEmailCTA = () => {
  return <div className='dca-marketing-connect-email-cta'>More questions? Email us at <a className="dca-marketing-page-email-link" href="mailto:info@nextfour.ai">info@nextfour.ai</a></div>
}

export { ConnectEmailCTA }